import type { LeadGroup } from '../../types/leadGroup';
import {
  Form,
  FormField,
  FormLabel,
  FormInput,
  Button,
} from '../ui';

interface LeadGroupFormProps {
  leadGroup: LeadGroup | null;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  onClose: () => void;
}

function LeadGroupForm({
  leadGroup,
  onSubmit,
  isLoading,
  onClose,
}: LeadGroupFormProps) {
  return (
    <Form onSubmit={onSubmit}>
      <FormField>
        <FormLabel htmlFor="description" required>
          Descrição
        </FormLabel>
        <FormInput
          id="description"
          name="description"
          type="text"
          maxLength={100}
          defaultValue={leadGroup?.description || ''}
          placeholder="Digite a descrição do grupo"
          required
        />
      </FormField>

      <FormField>
        <FormLabel htmlFor="daily_limit">
          Limite Diário
        </FormLabel>
        <FormInput
          id="daily_limit"
          name="daily_limit"
          type="number"
          min={0}
          defaultValue={leadGroup?.daily_limit ?? ''}
          placeholder="Deixe vazio para sem limite"
        />
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Limite diário para processamento de leads (deixe vazio para sem limite)
        </p>
      </FormField>

      <FormField>
        <FormLabel htmlFor="integration_key">
          Chave de Integração
        </FormLabel>
        <FormInput
          id="integration_key"
          name="integration_key"
          type="number"
          defaultValue={leadGroup?.integration_key ?? ''}
          placeholder="Chave de referência para sistemas externos"
        />
      </FormField>

      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Button type="submit" isLoading={isLoading} className="sm:col-start-2">
          {leadGroup ? 'Salvar' : 'Criar'}
        </Button>
        <Button type="button" variant="secondary" onClick={onClose} className="sm:col-start-1">
          Cancelar
        </Button>
      </div>
    </Form>
  );
}

export default LeadGroupForm;
